module.exports = __webpack_public_path__ + "img/indio_botella.2720feaf.png";